import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import RemarkGfm from 'remark-gfm';
import { TERMS_OF_BUSINESS_MD } from '../../data/markdown/cob';
import {
  MeDocument,
  useAcceptLicenseAgreementMutation,
} from '../../graphql/types';
import { Button } from '../button/button';
import { CheckBox } from '../checkbox/checkbox';
import { Heading } from '../heading/heading';
import { Actions, CheckboxItem, Content, Copy, Form, Sticky } from './shared';

interface TermsProps {
  onAccept?(): void;
  isReadonly?: boolean;
}

export function Terms({ onAccept, isReadonly }: TermsProps) {
  const [licenseAgreement, setLicenseAgreement] = useState(false);
  const [acceptLicenseAgreement, { loading }] =
    useAcceptLicenseAgreementMutation({
      variables: {
        licenseAgreement,
      },
    });
  const onTermsSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!licenseAgreement) {
      alert('You must agree to the privacy policy');
      return;
    }
    acceptLicenseAgreement({
      refetchQueries: [MeDocument],
      onCompleted() {
        onAccept?.();
      },
      onError(error) {
        if (error.graphQLErrors.find((e) => e.message.endsWith('E-451'))) {
          // Weird state: hard refresh
          (window as any).location.href = '/register';
        }
      },
    });
    return false;
  };

  return (
    <>
      <Content>
        <Heading center>Conditions of Business</Heading>
        <Copy>
          <ReactMarkdown remarkPlugins={[RemarkGfm]}>
            {TERMS_OF_BUSINESS_MD}
          </ReactMarkdown>
        </Copy>
      </Content>

      <Sticky>
        {isReadonly ? (
          <Form>
            <Actions>
              <Button as={Link} variant="secondary" to="/">
                Close
              </Button>
            </Actions>
          </Form>
        ) : (
          <Form onSubmit={onTermsSubmit}>
            <CheckboxItem>
              <CheckBox
                checked={licenseAgreement}
                onChange={(e) => setLicenseAgreement(e.target.checked)}
              >
                I agree to the Terms and Conditions
              </CheckBox>
            </CheckboxItem>
            <Actions>
              <Button as={Link} variant="secondary" to="/">
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={!licenseAgreement || loading}
                loading={loading}
              >
                Continue
              </Button>
            </Actions>
          </Form>
        )}
      </Sticky>
    </>
  );
}
